import { useModalState } from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useHistory, useRouteMatch } from "react-router-dom";

import { IconButton } from "../../components/IconButton";
import { type ShiftBlockWithMappedDetails } from "./api/useFetchPaginatedShiftBlocks";
import { CancelShiftBlockBottomSheet } from "./CancelShiftBlockBottomSheet";
import { SHIFT_BLOCK_ACTIONS } from "./utils";

interface Props {
  shiftBlockWithDetails: ShiftBlockWithMappedDetails;
}

export function CancelShiftBlockIconButton(props: Props) {
  const { shiftBlockWithDetails } = props;
  const cancelShiftBlockState = useModalState();
  const history = useHistory();
  const { path: currentRouterUrl } = useRouteMatch();
  if (!shiftBlockWithDetails.isShiftBlockAssigned) {
    return null;
  }

  return (
    <>
      <IconButton
        variant="ghost"
        iconType="ellipsis"
        size="small"
        aria-label="Cancel block"
        sx={{
          paddingRight: 0,
        }}
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.SHIFT_BLOCKS, {
            action: SHIFT_BLOCK_ACTIONS.CANCEL_BLOCK_TAPPED,
            shiftBlockId: shiftBlockWithDetails.id,
            facilityId: shiftBlockWithDetails.facility.id,
            location: currentRouterUrl,
          });
          cancelShiftBlockState.openModal();
        }}
      />
      <CancelShiftBlockBottomSheet
        modalState={cancelShiftBlockState}
        shiftBlockId={shiftBlockWithDetails.id}
        facilityId={shiftBlockWithDetails.facility.id}
        totalShifts={shiftBlockWithDetails.shifts.length}
        onConfirmCancellation={() => {
          history.goBack();
        }}
      />
    </>
  );
}
